@if (seo?.paragraphs?.length > 0) {
  <sd-seo-wrapper [data]="seo" [brand]="brandCorner" />
}
